module.exports = {
  areaUnits: ["m2", "square_foot"],
  assetCategories: ["office", "retail", "residential", "industrial", "warehouse", "multi_family",
    "hotel", "land", "other_cat"],
  assetFilters: ["keywords", "category", "region_ids", "status", "portfolio_ids", "size", "budget"],
  assetLeadActions: ["asset_lead_create", "asset_lead_stage_update", "asset_lead_status_update", "asset_lead_add_contact"],
  assetLeadContactCategories: ['landlord', 'asset_manager', 'property_manager', 'agent', 'tenant', 'key_holder', 'other'],
  assetLeadStages: ["prospect", "pitch", "negotiating", "closing"],
  assetPlaceholder: "https://s3.eu-central-1.amazonaws.com/rialto/assets/asset_placeholder.jpg",
  assetSortColumns: ["name", "on_market", "updated_at"],
  assetStatuses: ["invite", "private", "public", "sold", "fully_let", "other"],
  availableLocales: ["en", "en-GB", "fr-FR", "nl-NL", "nl-BE", "en-flex", "en-GB-flex", "fr-FR-flex", "nl-NL-flex", "nl-BE-flex",
    "en-acquisition", "en-GB-acquisition", "fr-FR-acquisition", "nl-NL-acquisition", "nl-BE-acquisition"],
  billingMethods: ["pre", "post"],
  capacityUnits: ["desk", "person", "room", "space", "parking", "floor"],
  channelCategories: ["tenant_rep", "leasing_agent", "website", "online_broker",
    "listing_site", "phone", "walk_in", "email", "referral", "employee_referral", "social_media", "other"],
  companyPageBlocks: ["incentives", "dealForm", "contacts", "portfolios"],
  companyRoles: ["owner", "broker"],
  companyTypes: ["leasing", "flex", "acquisition"],
  conversionToSqft: 10.76391041671,
  conversionToSqm: 0.09290304,
  currencies: ["CAD", "CHF", "DKK", "EUR", "GBP", "NOK", "SGD", "USD"],
  dealActions: ["deal_create", "deal_renewal", "deal_share_status_update", "deal_stage_update",
    "deal_create_no_asset", "deal_status_update", "deal_tenant_add", "deal_channel_add", "deal_lease_cancel",
    "deal_remove_asset", "deal_add_asset", "deal_point_person_change", "deal_accept_proposal", "deal_merge"],
  dealActivityLevels: ["lowest", "low", "medium", "high", "highest"],
  dealColumns: ["tenant", "point_person", "channel", "portfolio", "assets", "start_date", "size", "budget", "activity", "share_status", "term", "probability", "type", "location", "space_categories", "fee_potential"],
  dealFilters: ["keywords", "point_person_id", "channel_id", "asset_id", "stage", "status"],
  dealPosts: ["DealNote", "Viewing", "Call", "Email", "Proposal"],
  dealPostsInDigest: ["Call", "DealNote", "Email", "Viewing"],
  dealShareStatuses: ["owner_team", "broker_owner_team", "broker_team_owner_team", "custom", "all"],
  dealStages: ["signed_loi", "trading_proposal", "touring", "prospects"],
  dealStatuses: ["active", "dead", "executed"],
  dealTypes: ["new", "renewal", "expansion", "renegotiation", "reduction"],
  disregardOutcomes: ["move", "stay", "other_outcome"],
  disregardReasons: ["broker", "duplicate_entry", "tenant_unqualified", "location", "price", "timed_out", "size", "quality", "other_reason"],
  exportTypes: ["CSV", "PDF"],
  headCountValues: ["0-5", "5-10", "10-25", "25-50", "50-100", "100-250", "250-500", "500+"],
  industries: [
    "automobile", "aviation", "banks", "basic_resources", "chemicals", "construction",
    "culture", "education", "entertainment", "financial_services", "food", "healthcare",
    "household_goods", "industrial_goods", "insurance", "legal", "luxury", "media", "oil_gas",
    "professional_services", "public", "real_estate", "retail", "sports_leisure", "technology",
    "telecommunications", "travel", "utilities", "other",
  ],
  inventoryCategories: {
    car_parking: {
      period: "monthly",
      position: 7,
      unit: "parking",
    },
    covered_car_parking: {
      period: "monthly",
      position: 8,
      unit: "parking",
    },
    coworking: {
      period: "monthly",
      position: 11,
      unit: "desk",
    },
  },
  integrationCategories: ["listing_site", "crm", "property_management", "other"],
  integrationStatuses: ["connected", "disconnected", "requested"],
  landCodes: ["ABW", "AFG", "AGO", "AIA", "ALA", "ALB", "AND", "ARE", "ARG", "ARM", "ASM", "ATA",
    "ATF", "ATG", "AUS", "AUT", "AZE", "BDI", "BEL", "BEN", "BFA", "BGD", "BGR", "BHR", "BHS", "BIH",
    "BLM", "BLR", "BLZ", "BMU", "BOL", "BRA", "BRB", "BRN", "BTN", "BVT", "BWA", "CAF", "CAN", "CCK",
    "CHE", "CHL", "CHN", "CIV", "CMR", "COD", "COG", "COK", "COL", "COM", "CPV", "CRI", "CUB", "CUW",
    "CXR", "CYM", "CYP", "CZE", "DEU", "DJI", "DMA", "DNK", "DOM", "DZA", "ECU", "EGY", "ERI", "ESH",
    "ESP", "EST", "ETH", "FIN", "FJI", "FLK", "FRA", "FRO", "FSM", "GAB", "GBR", "GEO", "GGY", "GHA",
    "GIB", "GIN", "GLP", "GMB", "GNB", "GNQ", "GRC", "GRD", "GRL", "GTM", "GUF", "GUM", "GUY", "HKG",
    "HMD", "HND", "HRV", "HTI", "HUN", "IDN", "IMN", "IND", "IOT", "IRL", "IRN", "IRQ", "ISL", "ISR",
    "ITA", "JAM", "JEY", "JOR", "JPN", "KAZ", "KEN", "KGZ", "KHM", "KIR", "KNA", "KOR", "KWT", "LAO",
    "LBN", "LBR", "LBY", "LCA", "LIE", "LKA", "LSO", "LTU", "LUX", "LVA", "MAC", "MAF", "MAR", "MCO",
    "MDA", "MDG", "MDV", "MEX", "MHL", "MKD", "MLI", "MLT", "MMR", "MNE", "MNG", "MNP", "MOZ", "MRT",
    "MSR", "MTQ", "MUS", "MWI", "MYS", "MYT", "NAM", "NCL", "NER", "NFK", "NGA", "NIC", "NIU", "NLD",
    "NOR", "NPL", "NRU", "NZL", "OMN", "PAK", "PAN", "PCN", "PER", "PHL", "PLW", "PNG", "POL", "PRI",
    "PRK", "PRT", "PRY", "PSE", "PYF", "QAT", "REU", "ROU", "RUS", "RWA", "SAU", "SDN", "SEN", "SGP",
    "SGS", "SJM", "SLB", "SLE", "SLV", "SMR", "SOM", "SPM", "SRB", "SSD", "STP", "SUR", "SVK", "SVN",
    "SWE", "SWZ", "SXM", "SYC", "SYR", "TCA", "TCD", "TGO", "THA", "TJK", "TKL", "TKM", "TLS", "TON",
    "TTO", "TUN", "TUR", "TUV", "TWN", "TZA", "UGA", "UKR", "UMI", "URY", "USA", "UZB", "VAT", "VCT",
    "VEN", "VGB", "VIR", "VNM", "VUT", "WLF", "WSM", "YEM", "ZAF", "ZMB", "ZWE"],
  periods: {
    hourly: 8640,
    daily: 360,
    monthly: 12,
    yearly: 1,
  },
  permissions: ["deals", "assets", "asset_leads", "asset_deals"],
  portfolioTypes: ["leasing", "flex", "acquisition"],
  posts: ["Note", "Viewing", "Call", "Email", "Proposal"],
  postsInDigest: ["Call", "Note", "Email", "Viewing"],
  postParents: ["Deal", "AssetLead"],
  potential: ["low", "moderate", "average", "above_average", "high"],
  probabilities: ["0%", "5%", "25%", "50%", "75%", "100%"],
  sizeUnits: ["m2", "square_foot", "desk", "person", "room", "space", "parking", "floor"],
  sortDirections: ["ASC", "DESC"],
  flexSpaceCategories: ["residential", "retail", "office", "archive", "coworking", "meeting", "covered_car_parking", "car_parking", "other"],
  spaceCategories: {
    residential: {
      period: "monthly",
      position: 1,
      unit: "room",
    },
    retail: {
      period: "yearly",
      position: 2,
    },
    logistical: {
      period: "yearly",
      position: 3,
    },
    industrial: {
      period: "yearly",
      position: 4,
    },
    office: {
      period: "yearly",
      position: 5,
      unit: "desk",
    },
    showroom: {
      period: "yearly",
      position: 6,
    },
    storage: {
      period: "yearly",
      position: 7,
    },
    outdoor_area: {
      period: "yearly",
      position: 8,
    },
    land: {
      period: "yearly",
      position: 9,
    },
    archive: {
      period: "yearly",
      position: 10,
    },
    coworking: {
      period: "monthly",
      position: 11,
      unit: "desk",
    },
    meeting: {
      period: "hourly",
      position: 12,
      unit: "person",
    },
    leisure: {
      period: "yearly",
      position: 13,
    },
    covered_car_parking: {
      period: "monthly",
      position: 14,
      unit: "parking",
    },
    car_parking: {
      period: "monthly",
      position: 15,
      unit: "parking",
    },
    other: {
      period: "yearly",
      position: 99,
      unit: "space",
    },
  },
  spaceStatuses: ["public", "private"],
  subscriptionTypes: {
    asset_digest: "asset_id",
    asset: "asset_id",
    deal: "deal_id",
    deal_digest: "portfolio_id",
    portfolio_deal: "portfolio_id",
  },
  supportedImages: [".gif", ".jpg", ".jpeg", ".png"],
  termTypes: ["monthly", "yearly"],
  userRoles: ["account_holder", "administrator", "internal_user"],
};
